import * as teamsServices from './teamsServices';

export { teamsServices };
